import React from 'react';
import { Paperclip } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Checkbox } from '@/components/ui/checkbox';
import { DragDropZone } from './DragDropZone';

export const Step2Details = ({ formData, handleChange, tenant, files, setFiles, setError }) => (
  <div className="space-y-6">
    <div>
      <Label htmlFor="category">Categoria *</Label>
      <Select
        value={formData.category}
        onValueChange={(v) => handleChange('category', v)}
      >
        <SelectTrigger data-testid="category-select">
          <SelectValue placeholder="Selecione uma categoria" />
        </SelectTrigger>
        <SelectContent>
          {tenant.categories?.map((cat) => (
            <SelectItem key={cat} value={cat}>{cat}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>

    <div>
      <Label htmlFor="description">Descrição dos Factos *</Label>
      <Textarea
        id="description"
        value={formData.description}
        onChange={(e) => handleChange('description', e.target.value)}
        placeholder="Descreva detalhadamente os factos que pretende denunciar..."
        rows={6}
        data-testid="description-textarea"
      />
      <p className="text-sm text-slate-500 mt-1">
        {formData.description.length}/10000 caracteres (mínimo 50)
      </p>
    </div>

    <div className="grid grid-cols-2 gap-4">
      <div>
        <Label htmlFor="incident_date">Data Aproximada</Label>
        <Input
          id="incident_date"
          type="date"
          value={formData.incident_date}
          onChange={(e) => handleChange('incident_date', e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor="location">Local</Label>
        <Input
          id="location"
          value={formData.location}
          onChange={(e) => handleChange('location', e.target.value)}
          placeholder="Ex: Escritório Lisboa"
        />
      </div>
    </div>

    <div>
      <Label htmlFor="department">Departamento/Área</Label>
      <Input
        id="department"
        value={formData.department}
        onChange={(e) => handleChange('department', e.target.value)}
        placeholder="Ex: Financeiro, Comercial..."
      />
    </div>

    <div>
      <Label htmlFor="persons_involved">Pessoas Envolvidas (opcional)</Label>
      <Textarea
        id="persons_involved"
        value={formData.persons_involved}
        onChange={(e) => handleChange('persons_involved', e.target.value)}
        placeholder="Indique as pessoas envolvidas, se souber..."
        rows={3}
      />
      <p className="text-sm text-amber-600 mt-1">
        ⚠️ Tenha cuidado ao nomear pessoas. Apenas inclua se tiver fundamento.
      </p>
    </div>

    <div className="space-y-4 pt-4 border-t">
      <div className="flex items-start space-x-3">
        <Checkbox
          id="previously_reported"
          checked={formData.previously_reported}
          onCheckedChange={(v) => handleChange('previously_reported', v)}
        />
        <div>
          <Label htmlFor="previously_reported" className="cursor-pointer">
            Já reportei esta situação internamente
          </Label>
        </div>
      </div>

      {formData.previously_reported && (
        <Textarea
          value={formData.previous_report_details}
          onChange={(e) => handleChange('previous_report_details', e.target.value)}
          placeholder="Descreva como e quando reportou, e qual foi o resultado..."
          rows={3}
        />
      )}

      <div className="flex items-start space-x-3">
        <Checkbox
          id="reported_externally"
          checked={formData.reported_externally}
          onCheckedChange={(v) => handleChange('reported_externally', v)}
        />
        <div>
          <Label htmlFor="reported_externally" className="cursor-pointer">
            Já reportei a uma autoridade externa (MENAC, MP, regulador)
          </Label>
        </div>
      </div>

      {formData.reported_externally && (
        <Textarea
          value={formData.external_report_details}
          onChange={(e) => handleChange('external_report_details', e.target.value)}
          placeholder="Indique a que autoridade reportou e quando..."
          rows={3}
        />
      )}
    </div>

    {/* File Upload Section - Drag & Drop */}
    <div className="pt-4 border-t">
      <Label className="text-base font-medium mb-3 block">
        <Paperclip className="w-4 h-4 inline mr-2" />
        Anexos / Evidências (opcional)
      </Label>
      <p className="text-sm text-slate-500 mb-3">
        Arraste ficheiros ou clique para selecionar (máximo 10 ficheiros, 25MB cada)
      </p>

      <DragDropZone
        files={files}
        setFiles={setFiles}
        setError={setError}
        maxFiles={10}
        maxSize={25 * 1024 * 1024}
      />
    </div>
  </div>
);
